export const reqInitData =
  "00040081010000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";

export const KEY_MAP = {
  "00000": "00",
  "00010": "80",
  "00011": "c0",
  "00001": "40",

  10000: "10",
  10010: "90",
  10011: "d0",
  10001: "50",

  "01000": "01",
  "01010": "81",
  "01011": "c1",
  "01001": "41",

  "00100": "20",
  "00110": "a0",
  "00111": "e0",
  "00101": "60",

  11000: "11",
  11010: "91",
  11011: "d1",
  11001: "51",

  10100: "30",
  10110: "b0",
  10111: "f0",
  10101: "70",

  "01100": "21",
  "01110": "a1",
  "01111": "e1",
  "01101": "61",

  11100: "31",
  11110: "b1",
  11111: "f1",
  11101: "71",
};
